import React from 'react';
import { Box } from '../Box/Box';
import { Type } from '../Type/Type';

/**
 * Renders a gray box with an optional label. Useful for mocking up designs
 * or demonstrating layout primitives.
 */
export var Placeholder = function Placeholder(_ref) {
  var height = _ref.height,
      id = _ref.id,
      label = _ref.label,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 'auto' : _ref$width;
  return /*#__PURE__*/React.createElement(Box, {
    alignItems: "center",
    backgroundColor: "neutral-lightest",
    border: 2,
    borderColor: "neutral-light",
    display: "flex",
    justifyContent: "center",
    position: "relative",
    style: {
      width: width,
      height: height
    },
    id: id
  }, /*#__PURE__*/React.createElement(Type, {
    color: "neutral-darker"
  }, label));
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require -- directive added automatically by Shepherd migration
  var PropTypes = require('prop-types');

  Placeholder.propTypes = {
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.string,
    label: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };
}